export const CLEANUP_SIGN_IN_STATE = 'cleanup-sign-in-state';
const cleanupSignInState = () => ({ type: CLEANUP_SIGN_IN_STATE });
export default cleanupSignInState;
